import { render, staticRenderFns } from "./sitiosDeInteres.vue?vue&type=template&id=3003dadc&scoped=true"
import script from "./sitiosDeInteres.vue?vue&type=script&lang=js"
export * from "./sitiosDeInteres.vue?vue&type=script&lang=js"
import style0 from "./sitiosDeInteres.vue?vue&type=style&index=0&id=3003dadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3003dadc",
  null
  
)

export default component.exports